import * as React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentForm } from 'hooks/risks'
// components
import FilterButton from './components/FilterButton'
import VisibilityButton from './components/VisibilityButton'
// views
import {
  Button,
  EditIcon,
  TrashIcon,
  UnarchiveIcon,
  ButtonsWrapper
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { NewTabIcon } from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskContainer/components/ControllButton/views'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { Modals } from 'constants/modals'
import { FieldType, IField } from 'types/graphql'
// themes
import { colors } from 'themes/index'
// utils
import { isLinked } from 'utils/form'

interface Props {
  field: IField
  canEdit?: boolean
  archived?: boolean
  canDelete?: boolean
  onUnArchive?: () => void
  canUnarchive?: boolean
  linkedRiskId?: string
  onDeleteClick: () => void
}

const ControlButtons: React.FC<Props> = ({
  field,
  canEdit = true,
  archived,
  canDelete = true,
  onUnArchive,
  canUnarchive,
  linkedRiskId,
  onDeleteClick
}) => {
  const { linked } = useCurrentForm()

  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const fieldLink = riskTemplate?.fieldLinks?.find(
    ({ field: { id }, parentFieldId }) => id === field.id && parentFieldId === field.parentFieldId
  )

  const { showModal: showFieldDetails } = useShowModal({ modalType: Modals.PROPERTY_DETAILS_MODAL })
  const { showModal: showFormDetails } = useShowModal({ modalType: Modals.RISK_TEMPLATE_ADD_FORM_MODAL })

  const showDetailsDrawer = () => {
    if (fieldLink) {
      showFormDetails({
        field,
        linked: isLinked(fieldLink?.linkingSettings),
        parentId: field.parentFieldId
      })
    } else {
      showFieldDetails({ property: field })
    }
  }

  const onLinkClick = () => {
    window.open(`/forms/edit/${linkedRiskId}/template/${fieldLink.field.entityId}`, '_blank')
  }

  const canFilter = field.fieldType === FieldType.Lookup

  if (!canDelete && !canEdit && !linked) {
    return null
  }

  return (
    <ButtonsWrapper>
      {linkedRiskId && (
        <Button data-testid='open-linked-risk' data-entity-id={linkedRiskId} onClick={onLinkClick}>
          <NewTabIcon />
        </Button>
      )}
      {canEdit && (
        <Button onClick={showDetailsDrawer}>
          <EditIcon />
        </Button>
      )}
      {!fieldLink && (
        <>
          {canFilter && <FilterButton field={field} />}
          <VisibilityButton field={field} />
        </>
      )}
      {canUnarchive && (
        <Button onClick={onUnArchive}>
          <UnarchiveIcon />
        </Button>
      )}
      {canDelete && (
        <Button onClick={onDeleteClick}>
          <TrashIcon $color={archived ? colors.red300 : colors.blue500} />
        </Button>
      )}
    </ButtonsWrapper>
  )
}
export default ControlButtons
